<app-navbar>
    <h2>Cariera Mea - Editeaza profilul</h2>
</app-navbar>

<div class="container">
    <app-check-current-user></app-check-current-user>
</div>



<div class="container">
    <div class="edit-candidate-container">
        <div class="edit-candidate-inner">

            <app-form-message [success]="formResponse" *ngIf="formSent" [customErrorMessage]="'Câmpurile obligatorii nu au fost completate sau Fișierul incarcat nu este permis'" id="app-form-message"></app-form-message>


            <form (ngSubmit)="onSubmit(editProfile)" #editProfile="ngForm" *ngIf="formIsGenerated"
                  class="custom-form-one">
                <!-- Datele mele -->
                <div class="form-section pt-10">
                    <div class="form-section-title">
                        <h5 class="custom-section-title">Datele tale</h5>
                    </div>
                    <div class="form-block">
                        <div class="form-row">
                            <div class="col-md-6">
                                <label for="lastName">Nume</label>
                                <input type="text" id="lastName" class="form-control" [ngModel]=userData.lastName
                                       name="lastName" #lastName="ngModel" required (change)="letterCheck(lastName.name, lastName.value)">
                                <div class="error-msg" *ngIf="!lastName.valid && (lastName.touched || editProfile.submitted)">
                                    {{'VALIDATION.REQUIRED' | translate}}
                                </div>
                                <div class="error-msg"
                                *ngIf="lastNameFail">
                                {{'VALIDATION.ONLY_LETTERS' | translate}}
                                </div>
                            </div>
                            <div class="col-md-6">
                                <label for="lastName">{{'LOGIN.FIRST_NAME' | translate}}</label>
                                <input type="text" id="firstName" class="form-control" [ngModel]=userData.firstName
                                       name="firstName" #firstName="ngModel" required (change)="letterCheck(firstName.name, firstName.value)">
                                <div class="error-msg"  *ngIf="!firstName.valid && (firstName.touched || editProfile.submitted)">
                                    {{'VALIDATION.REQUIRED' | translate}}
                                </div>
                                <div class="error-msg"
                                *ngIf="firstNameFail">
                                {{'VALIDATION.ONLY_LETTERS' | translate}}
                                </div>
                            </div>
                            <div class="col-md-6">
                                <label for="email">Adresa Email</label>
                                <input type="text" id="email" class="form-control" [ngModel]=userData.email name="email"
                                       #email="ngModel" disabled>
                            </div>
                            <div class="col-md-6">
                                <label for="telephone">Telefon</label>
                                <input type="tel" id="telephone" class="form-control" [ngModel]=userData.telephone pattern="[0-9]{3}[0-9]{3}[0-9]{4}"
                                       name="telephone" #telephone="ngModel" required>
                                <div class="error-msg"  *ngIf="!telephone.valid && (telephone.touched || editProfile.submitted)">
                                    {{'VALIDATION.ONLY_NUMBERS' | translate}}
                                </div>
                            </div>
                            <div class="col-md-12">
                                <label for="dateOfBirth">Data nasterii</label>
                                <input type="date" id="dateOfBirth" class="form-control" [ngModel]="userData.dateOfBirth | date:'yyyy-MM-dd'"
                                       name="dateOfBirth" #dateOfBirth="ngModel" required max="{{currentDate | date: 'yyyy-MM-dd'}}">
                                <div class="error-msg" *ngIf="underAge && (dateOfBirth.touched || editProfile.submitted)">
                                    Acest camp este obligatoriu si trebuie sa aveti minim 16 ani!
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Contul meu -->
                <div class="form-section pt-10">
                    <div class="form-section-title">
                        <h5 class="custom-section-title">Contul meu</h5>
                    </div>
                    <div class="form-block">
                        <div class="form-row">
                            <div class="col-md-12 profilePhotoSection">
                                <div *ngIf="userData.profileImageId != null">
                                    <label>Foto profil</label>
                                    <img src={{profilePicturePath}}  alt="profile image" class="userProfilePicture" />
                                </div>
                                <div>
                                    <label *ngIf="userData.profileImageId == null">Adauga imagine de profil</label>
                                    <label *ngIf="userData.profileImageId != null">Schimba imagine de profil</label>
                                    <input type="file" class="form-control"  (change)="selectFile($event)" />
                                </div>
                            </div>
                            <div *ngIf="message" class="error-msg" role="alert">{{ message }}</div>


                            <!--                            Start cascade dropdown 1 -->
                            <div class="col-md-6">
                                <label>Tara domiciliu</label>
                                <div class="card-container">
                                    <select placeholder="Country" [(ngModel)]="selectedCountry" (change)="changeCountry($event)"
                                            class="form-control" name="userCountry"  id="userCountry" #userCountry="ngModel" required>
                                        <option value=" " selected disabled>{{'DROPDOWN.COUNTRY' | translate}}</option>
                                        <option *ngFor="let country of Countries">{{country.name}}</option>
                                    </select>
                                    <span class="help-block" *ngIf="!userCountry.valid && (userCountry.touched || editProfile.submitted)">{{'VALIDATION.REQUIRED' | translate}}</span>
                                </div>
                            </div>


                            <div class="col-md-6">
                                <label>Judet domiciliu</label>
                                <select placeholder="State" class="form-control" name="userCity" id="userCity" [(ngModel)]="selectedCity" #userCity="ngModel" required>
                                    <option [ngValue]="" selected disabled>{{'DROPDOWN.COUNTY' | translate}}</option>
                                    <option *ngFor="let city of cities">{{city}}</option>
                                </select>
                                <span class="help-block" *ngIf="!userCity.valid && (userCity.touched || editProfile.submitted)">{{'VALIDATION.REQUIRED' | translate}}</span>
                            </div>
                            <!--                            End cascade dropdown-->

                            <div class="col-md-12">
                                <label for="address">Adresa</label>
                                <input type="text" id="address" class="form-control" [ngModel]="userData.address"
                                       name="address" #address="ngModel">
                                <div class="error-msg" *ngIf="!address.valid && address.touched">
                                    {{'VALIDATION.REQUIRED' | translate}}
                                </div>
                            </div>

                            <div class="col-md-6">
                                <label for="civilStatus">Stare civila</label>
                                <select type="text" id="civilStatus" class="form-control" [ngModel]=userData.civilStatus
                                        name="civilStatus" #civilStatus="ngModel">
                                    <option value="" selected disabled hidden> -- Selecteaza optiune --</option>
                                    <option class="form-control" value="unmarried">Necasatorit/a</option>
                                    <option class="form-control" value="married">Casatorit/a</option>
                                    <option class="form-control" value="divorced">Divortat/a</option>
                                    <option class="form-control" value="widower">Vaduv/a</option>
                                </select>
                            </div>

                            <div class="col-md-6">
                                <label for="gender">Sex</label>
                                <select type="text" id="gender" class="form-control" [ngModel]=userData.gender
                                        name="gender" #gender="ngModel">
                                    <option value="" selected disabled hidden> -- Selecteaza optiune --</option>
                                    <option class="form-control" value="male">Barbat</option>
                                    <option class="form-control" value="female">Femeie</option>
                                    <option class="form-control" value="other">Alta varianta</option>
                                </select>
                            </div>

                            <div class="col-md-6">
                                <label>Profil Linkedin</label>
                                <input id="linkedinProfile" class="form-control"
                                       [ngModel]=userData.linkedinProfile name="linkedinProfile"
                                       #linkedinProfile="ngModel" type="url" pattern="https://.*" placeholder="https://exemplu.com">
                                    <div class="error-msg" *ngIf="!linkedinProfile.valid && (linkedinProfile.touched || editProfile.submitted)">
                                        Va rugam, Introduceti un profil de LinkedIn valid
                                    </div>
                            </div>

                            <div class="col-md-6">
                                <label>Profil Facebook</label>
                                <input type="url" pattern="https://.*" placeholder="https://exemplu.com"
                                       id="facebookProfile" class="form-control"
                                       [ngModel]=userData.facebookProfile name="facebookProfile"
                                       #facebookProfile="ngModel">
                                    <div class="error-msg" *ngIf="!facebookProfile.valid && (facebookProfile.touched || editProfile.submitted)">
                                        Va rugam, Introduceti un profil de Facebook valid
                                    </div>
                            </div>

                            <div class="col-md-6">
                                <label>Profil Youtube</label>
                                <input id="youtubeProfile" class="form-control"
                                       [ngModel]=userData.youtubeProfile name="youtubeProfile" #youtubeProfile="ngModel"
                                       type="url" pattern="https://.*" placeholder="https://exemplu.com">
                                    <div class="error-msg" *ngIf="!youtubeProfile.valid && (youtubeProfile.touched || editProfile.submitted)">
                                        Va rugam, Introduceti un profil de Youtube valid
                                    </div>
                            </div>

                            <div class="col-md-6">
                                <label>Profil Twitter</label>
                                <input id="twitterProfile" class="form-control"
                                       [ngModel]=userData.twitterProfile name="twitterProfile" #twitterProfile="ngModel"
                                       type="url" pattern="https://.*" placeholder="https://exemplu.com" >
                                    <div class="error-msg" *ngIf="!twitterProfile.valid && (twitterProfile.touched || editProfile.submitted)">
                                        Va rugam, Introduceti un profil de Twitter valid
                                    </div>
                            </div>

                            <div class="col-md-12">
                                <label>Alt canal social media</label>
                                <input id="anotherSocialMediaAccount" class="form-control"
                                       [ngModel]=userData.anotherSocialMediaAccount name="anotherSocialMediaAccount"
                                       #anotherSocialMediaAccount="ngModel"  type="url" pattern="https://.*" placeholder="https://exemplu.com">
                                    <div class="error-msg" *ngIf="!anotherSocialMediaAccount.valid && (anotherSocialMediaAccount.touched || editProfile.submitted)">
                                        Va rugam, Introduceti un profil valid
                                    </div>
                            </div>

                            <div class="col-md-12">
                                <label>Link Video CV</label>
                                <input id="linkVideoCV" class="form-control"
                                       [ngModel]=userData.linkVideoCV name="linkVideoCV"
                                       #linkVideoCV="ngModel"  type="url" pattern="https://.*" placeholder="https://www.youtube.com/watch?v=k5AQCJUbwio">
                                    <div class="error-msg" *ngIf="!linkVideoCV.valid && (linkVideoCV.touched || editProfile.submitted)">
                                        Va rugam, Introduceti un link Youtube valid
                                    </div>
                            </div>

                            <div class="col-md-6">
                                <label for="currentJob">Status job actual</label>
                                <select type="text" id="currentJob" class="form-control" [ngModel]=userData.currentJob
                                        name="currentJob" #currentJob="ngModel">
                                    <option value="" selected disabled hidden> -- Selecteaza optiune --</option>
                                    <option class="form-control" value="Studii">Studii</option>
                                    <option class="form-control" value="Angajat">Angajat</option>
                                    <option class="form-control" value="Fara job">Fara job</option>
                                    <option class="form-control" value="Voluntar">Voluntar</option>
                                    <option class="form-control" value="Internship">Internship</option>
                                    <option class="form-control" value="Angajat part time">Angajat part time</option>
                                    <option class="form-control" value="Angajat full time">Angajat full time</option>
                                    <option class="form-control" value="On project/temporar">On project/temporar
                                    </option>
                                    <option class="form-control" value="Freelancer(persona fizica)">Freelancer(persona
                                        fizica)
                                    </option>
                                    <option class="form-control" value="Freelancer(persona juridica)">Freelancer(persona
                                        juridica)
                                    </option>
                                    <option class="form-control" value="In cautare activa">In cautare activa</option>
                                    <option class="form-control" value="In cautare pasiva">In cautare pasiva</option>
                                    <option class="form-control" value="Antreprenor">Antreprenor</option>
                                </select>
                            </div>
                            <div class="col-md-6 col-12">
                                <label for="userDomain">Domeniu</label>
                                    <ng-select2 [data]="domainsArrayValues"
                                                [options]="domainOptions"
                                                id="userDomain"
                                                [(ngModel)]="selectedDomain"
                                                #userDomain="ngModel"
                                                name="userDomain"
                                                (valueChanged)="changeDomain($event)">
                                    </ng-select2>
                            </div>
                            <div class="col-md-6 col-12">
                                <label for="userDomain">Subdomeniu</label>
                                <ng-select2 [data]="subdomains"
                                            [options]="domainOptions"
                                            ngModel
                                            id="userSubdomain"
                                            [(ngModel)]="selectedSubDomain"
                                            #userSubdomain="ngModel"
                                            name="userSubdomain">
                                </ng-select2>
                            </div>
                            <div class="col-md-6">
                                <label for="userDepartment">Departament</label>
                                <ng-select2   id="userDepartment"
                                              #userDepartment="ngModel"
                                              name="userDepartment"
                                              [data]="departments"
                                              [options]="departmentsOptions"
                                              [(ngModel)]="userData.userDepartment" >
                                </ng-select2>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Mobilitate geografica -->
                <div class="form-section pt-10">
                    <div class="form-section-title">
                        <h5 class="custom-section-title">Mobilitate geografica</h5>
                    </div>
                    <div class="form-block">
                        <div class="form-row">
                            <div class="col-md-4">
                                <label for="regionOfInterest">Regiune de interes</label>
                                <select type="text" id="regionOfInterest" class="form-control"
                                        [ngModel]=userData.regionOfInterest name="regionOfInterest"
                                        #regionOfInterest="ngModel">
                                    <option value="" selected disabled hidden> -- Selecteaza optiune --</option>
                                    <option class="form-control" value="INTERNAL">Intern(Romania)</option>
                                    <option class="form-control" value="EXTERNAL">Extern(Strainatate)</option>
                                    <option class="form-control" value="MIXED">Mix</option>
                                </select>
                            </div>
                            <div class="col-md-4">
                                <label for="availabilityOfRelocation">Disponibilitate de relocare</label>
                                <select type="text" id="availabilityOfRelocation" class="form-control"
                                        [ngModel]=userData.availabilityOfRelocation name="availabilityOfRelocation"
                                        #availabilityOfRelocation="ngModel">
                                    <option value="" selected disabled hidden> -- Selecteaza optiune --</option>
                                    <option class="form-control" value="yes">Da</option>
                                    <option class="form-control" value="no">Nu</option>
                                    <option class="form-control" value="alone_in_romania">Singur in Romania</option>
                                    <option class="form-control" value="alone_in_eu">Singur in UE</option>
                                    <option class="form-control" value="with_family_in_romania">Cu familia in Romania
                                    </option>
                                    <option class="form-control" value="with_family_in_eu">Cu familia in UE</option>
                                </select>
                            </div>
                            <div class="col-md-4">
                                <label for="workPermissionInEu">Permis de munca in UE</label>
                                <select type="text" id="workPermissionInEu" class="form-control"
                                        [ngModel]=userData.workPermissionInEu name="workPermissionInEu"
                                        #workPermissionInEu="ngModel">
                                    <option value="" selected disabled hidden> -- Selecteaza optiune --</option>
                                    <option class="form-control" value="yes">Da</option>
                                    <option class="form-control" value="no">Nu</option>
                                    <option class="form-control" value="not_require">Nu este necesar</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Nivel experienta -->
                <div class="form-section pt-10">
                    <div class="form-section-title">
                        <h5 class="custom-section-title">Nivel experienta</h5>
                    </div>
                    <div class="form-block">
                        <div class="form-row">
                            <div class="col-md-6">
                                <label for="currentExperienceLevel">NIVELUL EXPERIENTEI ACTUALE</label>
                                <select type="text" id="currentExperienceLevel" class="form-control"
                                        [ngModel]=userData.currentExperienceLevel name="currentExperienceLevel"
                                        #currentExperienceLevel="ngModel">
                                    <option value="" selected disabled hidden> -- Selecteaza optiune --</option>
                                    <!-- <option class="form-control" value="student">Studii</option> -->
                                    <!-- <option class="form-control" value="entry_level">Entry-Level</option> -->
                                    <option class="form-control" value="no_experience">FARA EXPERIENTA</option>
                                    <option class="form-control" value="junior">JUNIOR (< 2 ani)</option>
                                    <option class="form-control" value="senior">SENIOR (> 5 ani)</option>
                                    <option class="form-control" value="specialist">SPECIALIST(2-5 ani)</option>
                                    <option class="form-control" value="executive">Manager / Executiv</option>
                                </select>
                            </div>
                            <div class="col-md-6">
                                <label for="desiredLevelOfJob">NIVEL DE JOB DORIT</label>
                                <select type="text" id="desiredLevelOfJob" class="form-control"
                                        [ngModel]=userData.desiredLevelOfJob name="desiredLevelOfJob"
                                        #desiredLevelOfJob="ngModel">
                                    <option value="" selected disabled hidden> -- Selecteaza optiune --</option>
                                    <!-- <option class="form-control" value="student">Studii</option> -->
                                    <!-- <option class="form-control" value="entry_level">Entry-Level</option> -->
                                    <option class="form-control" value="no_experience">FARA EXPERIENTA</option>
                                    <option class="form-control" value="junior">JUNIOR (< 2 ani)</option>
                                    <option class="form-control" value="senior">SENIOR (> 5 ani)</option>
                                    <option class="form-control" value="specialist">SPECIALIST(2-5 ani)</option>
                                    <option class="form-control" value="executive">Manager / Executiv</option>
                                </select>
                            </div>
                            <div class="col-md-6">
                                <label for="jobType">Tip job</label>
                                <select type="text" id="jobType" class="form-control" [ngModel]=userData.jobType
                                        name="jobType" #jobType="ngModel">
                                    <option value="" selected disabled hidden> -- Selecteaza optiune --</option>
                                    <option class="form-control" value="field_job">Job de teren</option>
                                    <option class="form-control" value="office_job">Job de birou</option>
                                    <option class="form-control" value="remote">Remote</option>
                                </select>
                            </div>
                            <div class="col-md-6">
                                <label for="availableForWork">Disponibilitate incepere job</label>
                                <select type="text" id="availableForWork" class="form-control"
                                        [ngModel]=userData.availableForWork name="availableForWork"
                                        #availableForWork="ngModel">
                                    <option value="" selected disabled hidden> -- Selecteaza optiune --</option>
                                    <option class="form-control" value="immediate">Imediata</option>
                                    <option class="form-control" value="in_30_days">In 30 zile</option>
                                    <option class="form-control" value="in_90_days">In 90 zile</option>
                                    <option class="form-control" value="in_6_months">In 6 luni</option>
                                    <option class="form-control" value="in_9_months">In 9 luni</option>
                                    <option class="form-control" value="in_12_months">In 12 luni</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>


                <!--BRANDUL TAU DE  CANDIDAT-->
                <div class="form-section pt-10">
                    <div class="form-section-title">
                        <h5 class="custom-section-title">Brandul tau de candidat</h5>
                    </div>
                    <div class="form-block">
                        <div class="form-row">
                            <div class="col-md-12">
                                <!--                                Certificari-->
                                <label class="label-with-button">Certificari (optional) <a class="form-control add" (click)="addCertification()">+</a></label>
                                <ng-template ngFor let-certification [ngForOf]="form.certification" let-index="index">
                                    <div class="dto-upload-block">
                                        <div class="row">
                                            <div class="col-md-5 dto-upload-file">
                                                <input class="form-control" type="text" placeholder="Enter Certification Name" [(ngModel)]="certification.title" name="certificationTitle_{{index}}"/>
                                                <a *ngIf="certification.link" href="{{certification.link}}" class="view-dto-upload" target="_blank">Vezi fisier</a>
                                                <input class="form-control" type="file" *ngIf="!certification.link"
                                                       name="file" id="certifLink_{{index}}" (change)="selectCertification($event, certification.title)"
                                                />
                                            </div>
                                            <div class="col-md-2 dto-upload-button">
                                                <a (click)="removeCertification( index );" title="Remove Certification" class="remove">
                                                    X
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </ng-template>
                            </div>
                            <div class="col-md-12">
                                <label class="label-with-button">Premii / Distinctii (optional) <a class="form-control add" (click)="addAwards()">+</a></label>
                                <ng-template ngFor let-award [ngForOf]="form.award" let-index="index">
                                    <div class="dto-upload-block">
                                        <div class="row">
                                            <div class="col-md-5 dto-upload-file">
                                                <input class="form-control" type="text" placeholder="Enter Award Name" [(ngModel)]="award.title" name="awardTitle_{{index}}"/>
                                                <a *ngIf="award.link" href="{{award.link}}" class="view-dto-upload" target="_blank">Vezi fisier</a>
                                                <input class="form-control" type="file"
                                                       name="link"
                                                       id="awardLink_{{index}}"
                                                       (change)="selectAwards($event, award.title)"
                                                       *ngIf="!award.link"
                                                />
                                            </div>
                                            <div class="col-md-2 dto-upload-button">
                                                <a (click)="removeAwards( index )" title="Remove Awards" class="remove">
                                                    X
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </ng-template>
                            </div>
                            <div class="col-md-12">
                                <label class="label-with-button">Clasamente, topuri (optional) <a class="form-control add" (click)="addTop()">+</a></label>
                                <ng-template ngFor let-top [ngForOf]="form.top" let-index="index">
                                    <div class="dto-upload-block">
                                        <div class="row">
                                            <div class="col-md-5 dto-upload-file">
                                                <input class="form-control" type="text" placeholder="Enter Clasament Name" [(ngModel)]="top.title" name="topTitle_{{index}}"/>
                                                <a *ngIf="top.link" href="{{top.link}}" class="view-dto-upload" target="_blank">Vezi fisier</a>
                                                <input class="form-control" type="file"
                                                       name="file" id="topLink_{{index}}"
                                                       (change)="selectTops($event, top.title)"
                                                       *ngIf="!top.link"
                                                />
                                            </div>
                                            <div class="col-md-2 dto-upload-button">
                                                <a (click)="removeTop( index )" title="Remove Top" class="remove">
                                                    X
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </ng-template>
                            </div>
                            <div class="col-md-12">
                                <label class="label-with-button">Testimoniale/ recomandari <a class="form-control add" (click)="addTestim()">+</a></label>
                                <ng-template ngFor let-testimonial [ngForOf]="form.testimonial" let-index="index">
                                    <div class="dto-upload-block">
                                        <div class="row">
                                            <div class="col-md-5 dto-upload-file">
                                                <input class="form-control" type="text" placeholder="Enter Testimonial Name" [(ngModel)]="testimonial.title" name="testimonailTitle_{{index}}"/>
                                                <a *ngIf="testimonial.link" href="{{testimonial.link}}" class="view-dto-upload" target="_blank">Vezi fisier</a>
                                                <input class="form-control" type="file"
                                                       (change)="selectTestim($event, testimonial.title)"
                                                       name="file" id="testimFile_{{index}}"
                                                       *ngIf="!testimonial.link"
                                                />
                                            </div>
                                            <div class="col-md-2 dto-upload-button">
                                                <a (click)="removeTestim( index )" title="Remove Testim" class="remove">
                                                    X
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </ng-template>
                            </div>
                            <div class="col-md-12">
                                <label class="label-with-button">Voluntariat <a class="form-control add" (click)="addVolunteer()">+</a></label>
                                <ng-template ngFor let-volunteer [ngForOf]="form.volunteer" let-index="index">
                                    <div class="dto-upload-block">
                                        <div class="row">
                                            <div class="col-md-5 dto-upload-file">
                                                <input class="form-control" type="text" placeholder="Enter Voluntariat Name" [(ngModel)]="volunteer.title" name="volunteerTitle_{{index}}"/>
                                                <a *ngIf="volunteer.link" href="{{volunteer.link}}" class="view-dto-upload" target="_blank">Vezi fisier</a>
                                                <input class="form-control" type="file"
                                                       name="file" id="link_{{index}}"
                                                       (change)="selectVolunteer($event, volunteer.title)"
                                                       *ngIf="!volunteer.link"
                                                />
                                            </div>
                                            <div class="col-md-2 dto-upload-button">
                                                <a (click)="removeVolunteer( index )" title="Remove Volunteer" class="remove">
                                                    X
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </ng-template>
                            </div>
                            <div class="col-md-12">
                                <label class="label-with-button">Implicare in actiuni sociale <a class="form-control add" (click)="addSocial()">+</a></label>
                                <ng-template ngFor let-social [ngForOf]="form.social" let-index="index">
                                    <div class="dto-upload-block">
                                        <div class="row">
                                            <div class="col-md-5 dto-upload-file">
                                                <input class="form-control" type="text" placeholder="Enter Social Name" [(ngModel)]="social.title" name="socialTitle_{{index}}"/>
                                                <a *ngIf="social.link" href="{{social.link}}" class="view-dto-upload" target="_blank">Vezi fisier</a>
                                                <input class="form-control" type="file"
                                                       name="file" id="socialActionFile_{{index}}"
                                                       (change)="selectSocial($event, social.title)"
                                                       *ngIf="!social.link"
                                                />
                                            </div>
                                            <div class="col-md-2 dto-upload-button">
                                                <a (click)="removeSocial( index )" title="Remove Social" class="remove">
                                                    X
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </ng-template>
                            </div>
                            <div class="col-md-12">
                                <label class="label-with-button">Hobby-uri si realizari personale <a class="form-control add" (click)="addHobbies()">+</a></label>
                                <ng-template ngFor let-hobbies [ngForOf]="form.hobbies" let-index="index">
                                    <div class="dto-upload-block">
                                        <div class="row">
                                            <div class="col-md-5 dto-upload-file">
                                                <input class="form-control" type="text" placeholder="Enter Hobbies Name" [(ngModel)]="hobbies.title" name="hobbiesTitle_{{index}}"/>
                                                <a *ngIf="hobbies.link" href="{{hobbies.link}}" class="view-dto-upload" target="_blank">Vezi fisier</a>
                                                <input class="form-control" type="file"
                                                       name="file" id="personalAchievementFile_{{ index }}"
                                                       (change)="selectHobby($event, hobbies.title)"
                                                       *ngIf="!hobbies.link"
                                                />
                                            </div>
                                            <div class="col-md-2 dto-upload-button">
                                                <a (click)="removeHobbies( index )" title="Remove Hobbies" class="remove">
                                                    X
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </ng-template>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-section pt-10">
                    <div class="form-block">
                        <div class="form-row">
                            <div class="col-md-12">
                                <label class="label-with-button">Cunostinte - studii <a class="form-control add" (click)="addStudies()">+</a></label>
                                <ng-template ngFor let-studies [ngForOf]="form.studies" let-index="index" ngModelGroup="allUserStudies"  [ngForTrackBy]="trackByFunction">
                                    <div class="studies">
                                        <div class="row" ngModelGroup="{{index}}">
                                            <div class="col-md-6">
                                                <label>Nivel de studii</label>
                                                <select class="form-control" name="userStudies" #userStudiesControl="ngModel"
                                                        [(ngModel)]="studies.userStudies" id="userStudies_{{index}}">
                                                    <option value="" selected disabled hidden>--- Selecteaza o optiune ---</option>
                                                    <option value="high_school">Liceu / Școală
                                                        profesionala </option>
                                                    <option value="college">Colegiu / Studii
                                                        postliceala </option>
                                                    <option value="faculty">Facultate</option>
                                                    <option value="master">Masterat</option>
                                                    <option value="MBA">MBA</option>
                                                    <option value="doctorate">Doctorat</option>
                                                    <option value="post_doctoral">Postdoctorale</option>
                                                </select>
                                                <div class="error-msg" *ngIf="!studies.userStudies.valid && (studies.userStudies.touched || editProfile.submitted)">
                                                    {{'VALIDATION.REQUIRED' | translate}}
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <label>Denumire institutie</label>
                                                <input class="form-control" #nameControl="ngModel" type="text"
                                                       name="studyName" id="studyName_{{index}}"
                                                       [(ngModel)]="studies.studyName"
                                                       placeholder="Denumire studii"/>
                                            </div>
                                            <div class="col-md-6">
                                                <label>Locatie (Oras, Tara)</label>
                                                <input class="form-control" #locationControl="ngModel" type="text"
                                                       name="studyLocation" id="studyLocation_{{index}}"
                                                       [(ngModel)]="studies.studyLocation" size="20"
                                                       placeholder="Locatie"/>
                                            </div>
                                            <div class="col-md-6">
                                                <label>Data de inceput</label>
                                                <input class="form-control" type="date"  #studyStartTime="ngModel"
                                                       name="studyStartDate" id="startStudyPeriod_{{index}}" [ngModel]="studies.studyStartDate | date:'yyyy-MM-dd'"
                                                       placeholder="Perioada de inceput"/>
                                            </div>
                                            <div class="col-md-6">
                                                <label>Data de sfarsit</label>
                                                <input class="form-control" type="date" #studyEndTime="ngModel"
                                                       name="studyEndDate" id="endStudyPeriod_{{index}}" [ngModel]="studies.studyEndDate | date:'yyyy-MM-dd'"
                                                       placeholder="Perioada de final" min="{{studies.studyStartDate }}"/>
                                            </div>
                                            <div class="col-md-11">
                                                <label>Diploma obtinuta</label>
                                                <input class="form-control" #diplomaControl="ngModel" type="text"
                                                       name="diplomaStudies" id="diplomaStudy_{{index}}"
                                                       [(ngModel)]="studies.diplomaStudies"
                                                       placeholder="Diploma"/>
                                            </div>
                                            <div class="col-md-1">
                                                <a (click)="removeStudies( index )" title="Remove Studies"
                                                   class="remove">
                                                    X
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <hr>
                                </ng-template>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-section pt-10">
                    <div class="form-block">
                        <div class="form-row">
                            <label class="label-with-button">Limbi straine <a class="form-control add" (click)="addUserLanguages()">+</a></label>
                            <div class="col-md-12">
                                <ng-template ngFor let-userLanguages [ngForOf]="form.userLanguages" let-index="index"  ngModelGroup="foreignLanguage" [ngForTrackBy]="trackByFunction">
                                    <div class="userLanguages">
                                        <div class="row" ngModelGroup="foreignLanguage_{{index}}">
                                            <div class="col-md-6">
                                                <ng-select2   id="foreignLanguage"
                                                              #foreignLanguage="ngModel"
                                                              name="language"
                                                              [data]="languages"
                                                              [options]="languageOptions"
                                                              [(ngModel)]="userLanguages.language" >
                                                </ng-select2>
                                            </div>
                                            <div class="col-md-5">
                                                <select id="foreignLanguageRating" name="level"
                                                        [(ngModel)]="userLanguages.level" class="form-control"  #languagesLevelControl="ngModel">
                                                    <option value="" selected disabled hidden> -- Selecteaza optiune
                                                        --
                                                    </option>
                                                    <option value="Incepator">Incepator</option>
                                                    <option value="Mediu">Mediu</option>
                                                    <option value="Avansat">Avansat</option>
                                                    <option value="Nativ">Nativ</option>
                                                </select>
                                            </div>
                                            <div class="col-md-1">
                                                <a (click)="removeUserLanguages( index )" title="Remove Languages"
                                                   class="remove">
                                                    X
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <hr>
                                </ng-template>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-section pt-10">
                    <div class="form-block">
                        <div class="form-row">
                            <div class="col-md-12">
                                <label for="userOtherCourses">Alte cursuri/ formari</label>
                                <textarea type="text" id="userOtherCourses" class="form-control"
                                          [ngModel]=userData.otherCourses name="userOtherCourses">
                                    </textarea>
                            </div>

                            <div class="col-md-12">
                                <label for="userPcKnowledge">Cunostinte PC</label>
                                <textarea type="text" id="userPcKnowledge" class="form-control"
                                          [ngModel]=userData.pcKnowledge name="userPcKnowledge">
                            </textarea>
                            </div>
                            <div class="col-md-6">
                                <label for="userDriverLicense">Permis de conducere</label>
                                <ng-select2 id="userDriverLicense"
                                            [(ngModel)]=userData.driverLicense name="userDriverLicense"
                                            [data]="driverLic"
                                            [options]="driverLicOptions">
                                </ng-select2>
                            </div>
                            <div class="col-md-6">
                                <label for="userAvailableForTraveling">Disponibilitate de deplasare</label>
                                <select type="text" id="userAvailableForTraveling" class="form-control"
                                        [ngModel]=userData.userAvailableForTraveling name="userAvailableForTraveling"
                                        >
                                    <option value="" selected disabled hidden> -- Selecteaza optiune --</option>
                                    <option class="form-control" value="10%">10%</option>
                                    <option class="form-control" value="25%">25%</option>
                                    <option class="form-control" value="50%">50%</option>
                                    <option class="form-control" value="100%">100%</option>
                                    <option class="form-control" value="A">Altele</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- PACHET SALARIAL IDEAL -->
                <div class="form-section pt-10">
                    <div class="form-section-title">
                        <h5 class="custom-section-title">Pachet salarial ideal</h5>
                    </div>
                    <div class="form-block">
                        <div class="form-row">
                            <div class="col-md-12">
                                <label for="userMinimumSalary">Salariu net fix minim</label>
                                <div class="input-group mb-2">
                                    <input type="number" id="userMinimumSalary" class="form-control mb-0"
                                           [ngModel]=userData.minimumSalary name="userMinimumSalary">
                                    <div class="input-group-append">
                                        <div class="input-group-text">€ / lunar</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <label for="interestedInBonusSystem">Interesat de sisteme bonusare</label>
                                <label for="interestedInBonusSystem" class="checkbox-container">DA
                                    <input type="checkbox" id="interestedInBonusSystem" name="interestedInBonusSystem"
                                           value=true [ngModel]=userData.interestedInBonusSystem>
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="col-md-4">
                                <label for="mandatoryMealVoucher">Bonuri de masa obligatorii</label>
                                <label for="mandatoryMealVoucher" class="checkbox-container">DA
                                    <input type="checkbox" id="mandatoryMealVoucher" name="mandatoryMealVoucher"
                                           value=true [ngModel]=userData.mandatoryMealVoucher>
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="col-md-4">
                                <label for="mandatoryHolidayVoucher">Bonuri de vacanta obligatorii</label>
                                <label for="mandatoryHolidayVoucher" class="checkbox-container">DA
                                    <input type="checkbox" id="mandatoryHolidayVoucher" name="mandatoryHolidayVoucher"
                                           value=true [ngModel]=userData.mandatoryHolidayVoucher>
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="col-md-4">
                                <label for="mandatoryServiceCar">Masina de serviciu obligatorie</label>
                                <label for="mandatoryServiceCar" class="checkbox-container">DA
                                    <input type="checkbox" id="mandatoryServiceCar" name="mandatoryServiceCar"
                                           value=true [ngModel]=userData.mandatoryServiceCar>
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="col-md-4">
                                <label for="mandatoryHealthPackage">Pachet de sanatate obligatoriu</label>
                                <label for="mandatoryHealthPackage" class="checkbox-container">DA
                                    <input type="checkbox" id="mandatoryHealthPackage" name="mandatoryHealthPackage"
                                           value=true [ngModel]=userData.mandatoryHealthPackage>
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="col-md-4">
                                <label for="mandatoryFood">Masa obligatorie</label>
                                <label for="mandatoryFood" class="checkbox-container">DA
                                    <input type="checkbox" id="mandatoryFood" name="mandatoryFood" value=true [ngModel]=userData.mandatoryFood>
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="col-md-4">
                                <label for="mandatoryAccommodation">Cazare obligatorie</label>
                                <label for="mandatoryAccommodation" class="checkbox-container">DA
                                    <input type="checkbox" id="mandatoryAccommodation" name="mandatoryAccommodation"
                                           value=true [ngModel]=userData.mandatoryAccommodation>
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="col-md-4">
                                <label for="coursesInTheCountry">Cursuri in tara</label>
                                <label for="coursesInTheCountry" class="checkbox-container">DA
                                    <input type="checkbox" id="coursesInTheCountry" name="coursesInTheCountry"
                                           value=true [ngModel]=userData.coursesInTheCountry>
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="col-md-4">
                                <label for="coursesAboard">Cursuri in afara tarii</label>
                                <label for="coursesAboard" class="checkbox-container">DA
                                    <input type="checkbox" id="coursesAboard" name="coursesAboard" value=true [ngModel]=userData.coursesAboard>
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

                <!--- CONDITII DE LUCRU IDEALE  -->
                <div class="form-section pt-10">
                    <div class="form-section-title">
                        <h5 class="custom-section-title">Conditii de lucru ideale</h5>
                    </div>
                    <div class="form-block">
                        <div class="form-row">
                            <div class="col-md-4">
                                <label for="userWorkProgram">Program de lucru</label>
                                <select type="text" id="userWorkProgram" class="form-control"
                                        [ngModel]=userData.userWorkProgram name="userWorkProgram">
                                    <option value="" selected disabled hidden> -- Selecteaza optiune --</option>
                                    <option class="form-control" value="fixed">Fix</option>
                                    <option class="form-control" value="flexible">Flexibil</option>
                                    <option class="form-control" value="exchanges">Schimburi</option>
                                    <option class="form-control" value="weekend_work">Lucru in weekend</option>
                                    <option class="form-control" value="other">Altul</option>
                                </select>
                            </div>
                            <div class="col-md-4">
                                <label for="userWorkSpace">Spatiu de lucru</label>
                                <select type="text" id="userWorkSpace" class="form-control"
                                        [ngModel]=userData.userWorkSpace name="userWorkSpace">
                                    <option value="" selected disabled hidden> -- Selecteaza optiune --</option>
                                    <option class="form-control" value="interior">Interior</option>
                                    <option class="form-control" value="exterior">Exterior</option>
                                </select>
                            </div>
                            <div class="col-md-4">
                                <label for="physicalEffortAvailability">Disponibilitate efort fizic</label>
                                <select type="text" id="physicalEffortAvailability" class="form-control"
                                        [ngModel]=userData.physicalEffortAvailability name="physicalEffortAvailability">
                                    <option value="" selected disabled hidden> -- Selecteaza optiune --</option>
                                    <option class="form-control" value="normal">Normal</option>
                                    <option class="form-control" value="additional">Suplimentar</option>
                                </select>
                            </div>
                            <div class="col-md-4">
                                <label for="weightLiftingAvailability">Disponibilitate ridicare greutati</label>
                                <select type="text" id="weightLiftingAvailability" class="form-control"
                                        [ngModel]=userData.weightLiftingAvailability name="weightLiftingAvailability">
                                    <option value="" selected disabled hidden> -- Selecteaza optiune --</option>
                                    <option class="form-control" value="no">Nu</option>
                                    <option class="form-control" value="maximum_10_kg">Pana in 10kg</option>
                                    <option class="form-control" value="maximum_25_kg">Pana in 25kg</option>
                                    <option class="form-control" value="maximum_50_kg">Pana in 50kg</option>

                                </select>
                            </div>
                            <div class="col-md-4">
                                <label for="workTemperature">De acord sa lucrezi la diferite temperaturi?</label>
                                <select type="text" id="workTemperature" class="form-control"
                                        [ngModel]=userData.workTemperature name="workTemperature">
                                    <option value="" selected disabled hidden> -- Selecteaza optiune --</option>
                                    <option class="form-control" value="no">Nu</option>
                                    <option class="form-control" value="yes">Da</option>
                                    <option class="form-control" value="low_temperature">Doar la temperaturi scazute
                                    </option>
                                    <option class="form-control" value="high_temperature">Doar la temperaturi ridicate
                                    </option>
                                </select>
                            </div>
                            <div class="col-md-4">
                                <label for="userCommute">Esti dispus sa faci naveta?</label>
                                <select type="text" id="userCommute" class="form-control"
                                        [ngModel]=userData.userCommute name="userCommute">
                                    <option value="" selected disabled hidden> -- Selecteaza optiune --</option>
                                    <option class="form-control" value="no">Nu</option>
                                    <option class="form-control" value="maximum_100_km">Pana in 100km</option>
                                    <option class="form-control" value="maximum_500_km">Pana in 500km</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>

                <!--- CONDITII DE LUCRU IDEALE -->
                <div class="form-section pt-10">
                    <div class="form-section-title">
                        <h5 class="custom-section-title">Cariera ideala</h5>
                    </div>
                    <div class="form-block">
                        <div class="form-row">
                            <div class="col-md-6">
                                <label for="idealCompany">Compania ideala</label>
                                <!-- <textarea rows="5" type="text" id="idealCompany" class="form-control"
                                          [ngModel]=userData.idealCompany name="idealCompany">
                            </textarea> -->
                            <angular-editor [(ngModel)]="userData.idealCompany"
                                            name="idealCompany"
                                            id="idealCompany"
                                            [config]="config" 
                                            #idealCompany='ngModel'                                         
                                            >
                            </angular-editor>
                            </div>
                            <div class="col-md-6">
                                <label for="idealJob">Jobul ideal</label>
                                <!-- <textarea rows="5" type="text" id="idealJob" class="form-control"
                                          [ngModel]=userData.idealJob name="idealJob">
                            </textarea> -->
                            <angular-editor [(ngModel)]="userData.idealJob"
                                            name="idealJob"
                                            id="idealJob"
                                            [config]="config" 
                                            #idealJob='ngModel'                                         
                                            >
                            </angular-editor>
                            </div>
                            <div class="col-md-6 offset-md-3">
                                <label for="idealBenefits">Beneficii ideale</label>
                                <textarea rows="5" type="text" id="idealBenefits" class="form-control"
                                          [ngModel]=userData.idealBenefits name="idealBenefits">
                            </textarea>
                            <!-- <angular-editor [(ngModel)]="userData.idealBenefits"
                                            name="idealBenefits"
                                            id="idealBenefits"
                                            [config]="config" 
                                            #idealBenefits='ngModel'                                         
                                            >
                            </angular-editor> -->
                            </div>
                        </div>
                    </div>
                </div>

                <!--MINI INTERVIU STANDARD AGRIBUSINESSJOB-->

                <!--Abilitatile mele-->
                <div class="form-section pt-10">
                    <div class="form-block">
                        <label class="label-with-button">Abilitatile mele <a class="form-control add" (click)="addSkills()">+</a></label>
<!--                        ----- TO DO de decomentat dupa ce da Andrei deploy la backend cu noile schimbari-->
                        <ng-template ngFor let-skills [ngForOf]="form.skills" let-index="index" ngModelGroup="ability" [ngForTrackBy]="trackByFunction">
                            <div class="skills">
                                <div class="row" ngModelGroup="ability{{index}}">
                                    <div class="col-md-5">
                                        <label>Nume abilitate</label>
                                        <input class="form-control" #abilityName="ngModel" type="text"
                                               name="abilityName" [(ngModel)]=skills.abilityName id="abilityName_{{index}}"
                                               placeholder="Abilitate"/>
                                    </div>
                                    <div class="col-md-5">
                                        <label>Nivel abilitate</label>
                                        <select class="form-control" #abilityLevel="ngModel"
                                               name="abilityLevel" [ngModel]=skills.abilityLevel id="abilityLevel_{{index}}">
                                                <option value="">--Alege nivelul de abilitate--</option>
                                                <option value="Baza">Baza</option>
                                                <option value="Mediu">Mediu</option>
                                                <option value="Avansat">Avansat</option>
                                                <option value="Expert">Expert</option>
                                        </select>
                                    </div>
                                    <div class="col-md-10">
                                        <label>Descriere abilitate</label>
                                        <textarea rows="5" class="form-control" #abilityDescription="ngModel" type="text"
                                                  name="abilityDescription"
                                                  [(ngModel)]="skills.abilityDescription"
                                                  placeholder="Principalele activitati"></textarea>
                                    </div>
                                    <div class="col-md-2">
                                        <a (click)="removeSkills( index )" title="Remove Skills" class="remove">
                                            X
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </div>
                </div>

                <!--Evolutie profesionala-->
                <div class="form-section pt-10">
                    <div class="form-block">
                        <label class="label-with-button">Evolutie profesionala <a class="form-control add" (click)="addCareer()">+</a> </label>
                        <ng-template ngFor let-career [ngForOf]="form.career" let-index="index" ngModelGroup="userExperience" [ngForTrackBy]="trackByFunction">
                            <div class="career">
                                <div class="row" ngModelGroup="userExperience_{{ index }}">
                                    <div class="col-md-3">
                                        <label>Functia / postul</label>
                                        <input class="form-control" #positionControl="ngModel" type="text"
                                               name="positionHeld" [(ngModel)]="career.positionHeld"
                                                size="20" placeholder="Functia/ postul..." required/>
                                        <div class="error-msg" *ngIf="!positionControl.valid && (positionControl.touched || editProfile.submitted)">
                                            {{'VALIDATION.REQUIRED' | translate}}
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <label>Angajator</label>
                                        <input class="form-control" #employerControl="ngModel" type="text"
                                               name="employer" [(ngModel)]="career.employer"
                                               placeholder="Angajator..." required />
                                        <div class="error-msg" *ngIf="!employerControl.valid && (employerControl.touched || editProfile.submitted)">
                                            {{'VALIDATION.REQUIRED' | translate}}
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="card-container">
                                            <label>Judetul</label>
                                            <input type="text" class="form-control" name="town"  #cityControl="ngModel"
                                                   [(ngModel)]="career.town"
                                                   placeholder="Judetul" required
                                            />
                                            <div class="error-msg" *ngIf="!cityControl.valid && (cityControl.touched || editProfile.submitted)">
                                                {{'VALIDATION.REQUIRED' | translate}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="card-container">
                                            <label>Tara</label>
                                            <input type="text" class="form-control" name="country"  #countryControl="ngModel"
                                                   [(ngModel)]="career.country" [(ngModel)]="career.country"
                                                   placeholder="Tara" required
                                            />
                                            <div class="error-msg" *ngIf="!countryControl.valid && (countryControl.touched || editProfile.submitted)">
                                                {{'VALIDATION.REQUIRED' | translate}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-2">
                                        <label>Data de inceput</label>
                                        <input class="form-control" #startDateControl="ngModel" type="date"
                                               name="jobStartDate" [ngModel]="career.jobStartDate | date:'yyyy-MM-dd'"
                                               placeholder="De la..." required/>
                                        <div class="error-msg" *ngIf="!startDateControl.valid && (startDateControl.touched || editProfile.submitted)">
                                            {{'VALIDATION.REQUIRED' | translate}}
                                        </div>
                                    </div>
                                    <div class="col-md-2">
                                        <label>Angajat in prezent?</label> 
                                        <label class="checkbox-container">DA
                                            <input type="checkbox" name="isStillEmployed"  #isStillEmployed="ngModel"
                                            [(ngModel)]="career.isStillEmployed" [(ngModel)]="career.isStillEmployed">
                                            <span class="checkmark"></span>
                                        </label>
                                    </div>
                                    <div class="col-md-2" *ngIf="!career.isStillEmployed">
                                        <label>Data de sfarsit</label>
                                        <input class="form-control" #endDateControl="ngModel" type="date" 
                                               name="jobEndDate" [ngModel]="career.jobEndDate | date:'yyyy-MM-dd'"
                                               placeholder="Pana la..."/>
                                    </div>
                                    <div class="col-md-3">
                                        <label>Principalele activitati</label>
                                        <textarea rows="5" class="form-control" #responsabilityControl="ngModel" type="text"
                                         name="mainResponsibility"
                                         [(ngModel)]="career.mainResponsibility"
                                         placeholder="Principalele activitati" required></textarea>
                                        <div class="error-msg" *ngIf="!responsabilityControl.valid && (responsabilityControl.touched || editProfile.submitted)">
                                            {{'VALIDATION.REQUIRED' | translate}}
                                        </div>
                                    </div>
                                    <div class="col-md-3 remove-career-container">
                                        <a (click)="removeCareer( index )" title="Remove Career" class="remove">
                                            X
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <hr>
                        </ng-template>
                    </div>
                </div>

                <button type="submit" class="form-control green-button">Salveaza</button>
<!--                <button type="submit" class="form-control green-button" [disabled]="!editProfile.valid">Salveaza</button>-->
            </form>
        </div>
    </div>
</div>
<app-footer></app-footer>
